export class PoGrnForQty{
    createdDate:string;
    poQty:number;
    grnQty:number;
    
}